import type { PropsWithChildren } from "react";

import styled from "styled-components";

import { useMonitorAndProtectDataAndParams } from "../../hooks/navigations";
import { useScrollPositionRestore } from "../../hooks/useScrollPositionRestore";

const Container = styled.div`
    overflow: auto;
`;

const InnerContainer = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
`;

export const Content = ({ children }: PropsWithChildren) => {
    const { showHeader } = useMonitorAndProtectDataAndParams();
    const containerRef = useScrollPositionRestore();

    return (
        <Container
            ref={containerRef}
            className={showHeader ? "sw-layout-research" : ""}
        >
            <InnerContainer className={showHeader ? "sw-layout-page" : ""}>{children}</InnerContainer>
        </Container>
    );
};
